module.exports = __webpack_public_path__ + "static/media/14.a1305d6f.png";